// extracted by mini-css-extract-plugin
export default {"main":"main-jBji","content":"content-IQ9M"};